import React from 'react';
import gfgLogo from '../static/img/gfg_pink_square.png';
import './frontpage.css';

export default function FrontPage() {
    return (
        <div className="frontpage-container">
            <img className="logo" src={gfgLogo} alt="GFG Esports 10th anniversary logo"/>
        </div>
    )
}